/*
 * Copyright (c) 2025 Rembrand Pardo
 * Unauthorized copying, modification, or redistribution is strictly prohibited.
 * Violators will face legal action.
 */

import React from 'react';

import { Linkedin, X, GithubThick, Instagram } from '../icons/Iconbuddy'; 
import { logEvent } from "firebase/analytics";
import { analytics } from "../firebaseConfig";
import '../styles/Footer.css';

const Footer = ({ translations }) => {
  const currentYear = new Date().getFullYear();

  // Function to log social media clicks
  const handleSocialClick = (platform) => {
    logEvent(analytics, "social_click", { platform });
    console.log(`Social media clicked: ${platform}`);
  };

  return (
    <footer className="footer">
      <p className="copyright">© {currentYear} Pardo. { translations.allRightsReserved }</p>
      <div className="social-icons">
        <a href="https://www.linkedin.com/in/rembrandpardo/" className="linkedin-icon" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn Profile"
        onClick={() => handleSocialClick("LinkedIn")}>
          <Linkedin />
        </a>
        <a href="https://github.com/Thebatman7" className="github-icon" target="_blank" rel="noopener noreferrer" aria-label="GitHub Profile"
        onClick={() => handleSocialClick("GitHub")}>
          <GithubThick />
        </a>
        <a href="https://www.instagram.com/rembrand.paul/" className="instagram-icon" target="_blank" rel="noopener noreferrer" aria-label="Instagram Profile"
        onClick={() => handleSocialClick("Instagram")}>
          <Instagram />
        </a>
        <a href="https://x.com/rembrandpardo" className="x-icon" target="_blank" rel="noopener noreferrer" aria-label="X (Twitter) Profile"
        onClick={() => handleSocialClick("X")}>
          <X />
        </a>
      </div>
    </footer>
  );
};

export default Footer;
